import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { PropsWithChildren } from 'react';

interface ConfirmationDialogProps {
  open: boolean;
  cancel(): void;
  ok(): void;
}
export const ConfirmationDialog = ({ open, ok, cancel, children }: PropsWithChildren<ConfirmationDialogProps>) => {
  return (
    <Dialog open={open}>
      <DialogContent>
        <DialogContentText>{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel}>cancel</Button>
        <Button onClick={ok}>ok</Button>
      </DialogActions>
    </Dialog>
  );
};
